import { Fragment } from 'react';
import { Link } from '@tanstack/react-router';

/** Telas que o plano liga entre si (usa = de onde vem o dado; alimenta = para onde ele vai). */
export type RotaRelacionada =
  | '/vender/orcamentos'
  | '/plano/carteira'
  | '/plano/necessidade'
  | '/plano/compras'
  | '/plano/custo-fabrica'
  | '/plano/fluxo'
  | '/custos/fichas-tecnicas'
  | '/cadastros/fornecedores'
  | '/configuracoes/plano';

export interface ItemRelacionado {
  rotulo: string;
  to: RotaRelacionada;
}

/**
 * Linha "Usa: ... · Alimenta: ..." logo abaixo do subtitulo de cada tela do plano.
 * So navegacao: nao calcula nada. Metade vazia some.
 */
export function UsaAlimenta({ usa = [], alimenta = [] }: { usa?: ItemRelacionado[]; alimenta?: ItemRelacionado[] }) {
  if (usa.length === 0 && alimenta.length === 0) return null;
  return (
    <p className="text-small text-ink-muted">
      {usa.length > 0 && <Lista prefixo="Usa" itens={usa} />}
      {usa.length > 0 && alimenta.length > 0 && ' · '}
      {alimenta.length > 0 && <Lista prefixo="Alimenta" itens={alimenta} />}
    </p>
  );
}

function Lista({ prefixo, itens }: { prefixo: string; itens: ItemRelacionado[] }) {
  return (
    <>
      {prefixo}:{' '}
      {itens.map((it, i) => (
        <Fragment key={it.to}>
          {i > 0 && ', '}
          <Link to={it.to} className="hover:text-ink-body hover:underline">
            {it.rotulo}
          </Link>
        </Fragment>
      ))}
    </>
  );
}
